import { useState, useEffect } from 'react';
import { fetchMinerstatHardware, convertMinerstatToMinerSpec, getFallbackMiners } from '../utils/api/minerstat';
import type { MinerSpec } from '../utils/minerTypes';

export function useMinerstat() {
  const [miners, setMiners] = useState<MinerSpec[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchMiners = async () => {
      try {
        setIsLoading(true);
        const minerstatData = await fetchMinerstatHardware();
        
        if (minerstatData.length === 0) {
          // Use fallback data if API fails
          setMiners(getFallbackMiners());
          setError('Using local miner data');
          return;
        }

        const convertedMiners = minerstatData
          .filter(miner => miner.type === 'asic')
          .map(miner => convertMinerstatToMinerSpec(miner))
          .filter((miner): miner is MinerSpec => miner !== null);
        
        if (convertedMiners.length === 0) {
          setMiners(getFallbackMiners());
          setError('No valid miners found - using local data');
        } else {
          setMiners(convertedMiners);
          setError(null);
        }
      } catch (err: any) {
        console.error('Error fetching miners:', err);
        setMiners(getFallbackMiners());
        setError('Failed to fetch miners - using local data');
      } finally {
        setIsLoading(false);
      }
    };

    fetchMiners();
  }, []);

  return { miners, isLoading, error };
}